/** Format API `lastUpdatedAt` (UTC ISO) for the logs list — no browser timezone shift. */
export function formatLogsLastUpdatedLabel(lastUpdatedAt: string | null | undefined): string {
  const raw = String(lastUpdatedAt ?? '').trim();
  if (!raw) {
    return '';
  }
  const date = new Date(raw);
  if (!Number.isFinite(date.getTime())) {
    return '';
  }
  const datePart = date
    .toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      timeZone: 'UTC',
    })
    .replace(/\s/g, ' ');
  const timePart = date.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZone: 'UTC',
  });
  return `${datePart}, ${timePart}`;
}
